import apiClient from './apiClient';
import { ENDPOINTS } from '../constants/api';

/**
 * Media Service
 * Handles file uploads to Spring Boot backend.
 */

/**
 * Uploads an image file to the backend server.
 * @param {File} file The local image file
 * @returns {Promise<string>} The uploaded image public URL on success
 */
export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('media', file);
  formData.append('mediaType', 'IMAGE');

  const { data: response } = await apiClient.post(
    `${ENDPOINTS.medias.upload}?mediaType=IMAGE`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  // Return the public URL from the backend's Media entity response
  return response?.data?.url;
}

/**
 * Deletes a media file by ID
 * @param {string} mediaId UUID of the media
 * @returns {Promise<object>}
 */
export async function deleteMedia(mediaId) {
  const { data: response } = await apiClient.delete(ENDPOINTS.medias.delete(mediaId));
  return response;
}
